@if (isLoadingFlagPassed()) {
    <div class="carousel-wrapper">
        @if (!showLoader()) {
            @if (products()?.length) {
                <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
                <ng-container *ngTemplateOutlet="sliderTemplate"></ng-container>
            }
        } @else if (showLoader()) {
            <ng-container *ngTemplateOutlet="skeletonTemplate"></ng-container>
        }
    </div>
} @else {
    <div class="carousel-wrapper">
        @if (products()?.length) {
            <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
            <ng-container *ngTemplateOutlet="sliderTemplate"></ng-container>
        } @else {
            <ng-container *ngTemplateOutlet="skeletonTemplate"></ng-container>
        }
    </div>
}

<ng-template #titleTemplate>
    <div class="carousel-title">
        <h2 class="section-heading">{{ title() }}</h2>
        <p class="body-0 carousel-title__subtitle">{{ subTitle() }}</p>
    </div>
</ng-template>

<ng-template #sliderTemplate>
    @if (isFetchResponseFailed()) {
        <div class="product-carousel container section-wrapper box-container">
            <lib-section-data-failure-error />
        </div>
    } @else {
        <div class="product-carousel container section-wrapper box-container">
            <lib-product-cards [products]="products()" [withControls]="withControls()"></lib-product-cards>
            @if (withAction()) {
                <div class="action-button-container">
                    <button mat-stroked-button [ariaLabel]="ariaLabelAction()" (click)="onAction()">
                        {{ actionText() }}
                    </button>
                </div>
            }
        </div>
    }
</ng-template>

<ng-template #skeletonTemplate>
    <div class="skeleton-wrapper">
        <ng-container *ngTemplateOutlet="skeletonService.productCardsTemplate()"></ng-container>
    </div>
</ng-template>
